module.exports = __webpack_public_path__ + "static/media/clever.8aea5464.webp";